import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Avatar,
  Card,
  Divider,
  Button,
  Modal,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import MasterLayout from "../../masterLayout/MasterLayout";
import axios from "axios";
import { baseUrl } from "../../helper/urls";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const StudentCounselorPage = () => {
  const { token } = useSelector((state) => state.auth);
  const { state } = useLocation();
  const navigate = useNavigate();
  // console.log("Counselor Profile Page State:", state);
  // const navigate = useNavigate();
  const counselor = state?.counselor;

  // const time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get local time zone
  // const utcTime = new Date().toISOString(); // Current time in UTC
  // console.log("Time Zone:", time_zone);
  // console.log("UTC Time:", utcTime);
  // Redirect to home if no counselor data (e.g., on page refresh)
  // if (!counselor) {
  //   navigate("/", { replace: true });
  //   return null;
  // }

  const BorderLine = () => (
    <Box sx={{ width: "100%", mt: 5, mb: 5 }}>
      <Divider
        sx={{
          borderBottomWidth: 1, // Thickness
          // bgcolor: "primary.main", // Color
          bgcolor: "black", // Color
        }}
      />
    </Box>
  );

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [timeValue, setTimeValue] = useState(null);
  // const [slotsValue, setSlotsValue] = useState(null);
  const [errors, setErrors] = useState({ time: false, slots: false });

  const [loading, setLoading] = useState(false); // fix camelCase

  const createBookingRequest = async () => {
    setLoading(true);

    // Extract local start hour from timeValue
    const startHourStr = timeValue?.split("-")[0]; // e.g., "9AM"
    const localTime = new Date();

    if (startHourStr) {
      // Convert "9AM" or "3PM" to 24-hour format number
      const hourMatch = startHourStr.match(/(\d+)(AM|PM)/);
      if (hourMatch) {
        let hour = parseInt(hourMatch[1]);
        const period = hourMatch[2];

        if (period === "PM" && hour !== 12) hour += 12;
        if (period === "AM" && hour === 12) hour = 0;

        // Set local time to selected hour with 0 minutes
        localTime.setHours(hour, 0, 0, 0);
      }
    }

    // Convert to UTC ISO string
    const utcTime = localTime.toISOString();

    try {
      const response = await axios.post(
        `${baseUrl}/api/booking_req/create`,
        {
          counselorId: counselor.id,
          call_time: timeValue,
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          utcTime: utcTime, // dynamically calculated based on selected slot
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response);
      if (response.data.success === true) {
        setOpen(false);
        handleApiSuccess(response);
        // toast.success(response.data.message || "Request created successfully!");

        // Swal.fire({
        //   text: response?.data?.message || "Role updated successfully",
        //   icon: "success",
        //   // timer: 3000,
        //   // showConfirmButton: false,
        // });

        // navigate("/student-requested-slot-list");
      }
    } catch (error) {
      console.error(
        "Booking request failed:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message || "Failed to create booking request"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleApiSuccess = (response) => {
    Swal.fire({
      // text: response?.data?.message || "Role updated successfully",
      text: "Request created successfully",

      icon: "success",
      timer: 4000,
      showConfirmButton: true, // optional: allow manual dismissal
      allowOutsideClick: true,
      allowEscapeKey: true,
    }).finally(() => {
      navigate("/student-requested-slot-list");
    });
  };

  const handleSubmit = () => {
    const newErrors = {
      time: !timeValue,
      // slots: !slotsValue,
    };
    setErrors(newErrors);
    // if (!newErrors.time && !newErrors.slots) {
    if (!newErrors.time) {
      createBookingRequest();
    }
  };

  return (
    <MasterLayout>
      <ToastContainer position="top-right" autoClose={2000} />
      <Box sx={{ display: "flex", flexDirection: "column", p: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItem: "center",
            p: 10,
            // backgroundColor: "#c8e5ea",
            background:
              "linear-gradient(to right, rgb(0, 158, 180), rgb(0, 216, 210))",

            borderRadius: 2,
            //   boxShadow: 3,
          }}
        >
          <Typography variant="h1" color="#e8fafe">
            <i> {`${counselor?.firstName} ${counselor?.lastName}`}</i>
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItem: "center",
            p: 10,
            //   backgroundColor: "green",
          }}
        >
          {/* <Avatar
            // src={""}
            src={`${baseUrl}${counselor.profileImage}`}
            // src={`https://images.unsplash.com/photo-1575936123452-b67c3203c357?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D`}
            alt={"Counselor Name"}
            sx={{
              width: 250,
              height: 250,
              mx: "auto",
              mt: -16,
              mb: -6,
              border: "3px solid white",
              boxShadow: 2,
              bgcolor: "#124178",
              fontSize: 52,
            }}
          >
            {counselor.firstName?.[0]?.toUpperCase()}
            {counselor.lastName?.[0]?.toUpperCase()}
          </Avatar> */}
          <Avatar
            src={
              counselor?.profileImage
                ? `${baseUrl}${counselor?.profileImage}`
                : ""
            }
            alt={counselor?.firstName}
            sx={{
              width: 250,
              height: 250,
              mx: "auto",
              mt: -16,
              mb: -6,
              boxShadow: 2,
              // Conditional styling based on profileImage availability
              ...(counselor?.profileImage
                ? { border: "2px solid #124178", bgcolor: "#ffffff" } // If profileImage is available, show border and transparent background
                : { bgcolor: "#124178" }), // If no profileImage, show background color
              fontSize: 52,
            }}
          >
            {/* Only show initials if profileImage is not available */}
            {!counselor?.profileImage &&
              counselor?.firstName?.[0]?.toUpperCase()}
            {!counselor?.profileImage &&
              counselor?.lastName?.[0]?.toUpperCase()}
          </Avatar>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItem: "center",
            //   p: 10,
          }}
        >
          <Typography variant="body1">{`${counselor?.testimony}`}</Typography>
        </Box>

        {/* <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            mb: 0,
            mt: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItem: "center",
              mb: 3,
              borderRadius: 2,
              p: 2,
              backgroundColor: "#f0f4f8",
            }}
          >
            <Typography variant="body1" mb={1}>
              <strong>University</strong>
            </Typography>
            <Typography variant="body2" mb={1}>
              {counselor.universityName}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItem: "center",
              mb: 3,
              borderRadius: 2,
              p: 2,
              backgroundColor: "#f0f4f8",
            }}
          >
            <Typography variant="body1" mb={1}>
              <strong>SAT/ACT SCORE</strong>
            </Typography>
            <Typography variant="body2" mb={1}>
              {counselor.satActScore}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItem: "center",
              mb: 3,
              borderRadius: 2,
              p: 2,
              backgroundColor: "#f0f4f8",
            }}
          >
            <Typography variant="body1" mb={1}>
              <strong>Service Type</strong>
            </Typography>
            <Typography variant="body2" mb={1}>
              {counselor.interestedIn}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItem: "center",
              mb: 3,
              borderRadius: 2,
              p: 2,
              backgroundColor: "#f0f4f8",
            }}
          >
            <Typography variant="body1" mb={1}>
              <strong>Major Course</strong>
            </Typography>
            <Typography variant="body2" mb={1}>
              {counselor.majorCourse}
            </Typography>
          </Box>
        </Box> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            mt: 3,
          }}
        >
          {[
            {
              label: "University",
              value: counselor?.universityName,
            },
            {
              label: "SAT/ACT SCORE",
              value: counselor?.satActScore,
            },

            {
              label: "Major Course",
              value: counselor?.majorCourse,
            },
          ].map((item, idx) => (
            <Card
              sx={{
                display: "flex",
                width: 200,
                height: 150,
                borderRadius: 4,
                boxShadow: 3,
                overflow: "hidden",
                textAlign: "left",
              }}
            >
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center", // fixed typo
                  // mb: 3,
                  borderRadius: 2,
                  // p: 5,
                  width: 200,
                  backgroundColor: "#f0f4f8",
                  textAlign: "center",
                }}
              >
                <Typography variant="body1" mb={1} fontWeight="bold">
                  {item.label}
                </Typography>
                <Typography variant="body2">{item.value}</Typography>
              </Box>
            </Card>
          ))}
        </Box>

        <Box>
          <Button
            sx={{
              // width: "100%",
              mt: 4,
              mb: 2,
              px: 6,

              backgroundColor: "#124178",
              color: "white",
              fontSize: 20,
              fontWeight: "bold",
              float: "right",
              borderRadius: 5,
            }}
            variant="contained"
            onClick={handleOpen}
          >
            Request
          </Button>
        </Box>
      </Box>
      <div>
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography sx={{ mb: 1 }}>Select Time</Typography>
            <Autocomplete
              options={["9AM-12PM", "12PM-3PM", "3PM-6PM", "6PM-9PM"]}
              value={timeValue}
              onChange={(event, newValue) => setTimeValue(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Best time to call"
                  variant="outlined"
                  error={errors.time}
                  helperText={errors.time ? "This field is required" : ""}
                />
              )}
              sx={{ width: "100%" }}
            />

            {/* <Typography sx={{ mt: 2, mb: 1 }}>Number of Slots</Typography>
            <Autocomplete
              options={["5", "10", "15"]}
              value={slotsValue}
              onChange={(event, newValue) => setSlotsValue(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="No. of Slots"
                  variant="outlined"
                  error={errors.slots}
                  helperText={errors.slots ? "This field is required" : ""}
                />
              )}
              sx={{ width: "100%" }}
            /> */}

            <Button
              // loading={loading}
              disabled={loading}
              variant="contained"
              sx={{
                mt: 3,
                width: "100%",
                backgroundColor: "#124178",
                color: "white",
              }}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress /> : "Submit"}
            </Button>
          </Box>
        </Modal>
      </div>
    </MasterLayout>
  );
};

export default StudentCounselorPage;
